import React, { useEffect, useState } from 'react'
import { BrowserRouter, StaticRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

// @ts-ignore
const UniversalRouter = (props) => {
  const { isMountedCallback } = props
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)

    if (isMountedCallback) {
      isMountedCallback(true)
    }
  }, [])

  const Router = mounted ? BrowserRouter : StaticRouter

  // @ts-ignore
  return <Router {...props} />
}

UniversalRouter.propTypes = {
  context: PropTypes.shape({}),
  isMountedCallback: PropTypes.func,
}

UniversalRouter.defaultProps = {
  context: {},
  isMountedCallback: (isMounted) => isMounted,
}

export default UniversalRouter
